export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[640px] w-full items-center overflow-hidden bg-foreground-950 md:min-h-[720px]"
    >
      {/* 背景大图 */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=epic%20anime%20battle%20scene%20of%20ninjas%20using%20fire%20and%20wind%20jutsus%20in%20night%20sky%20over%20leaf%20village%2C%20giant%20fox%20silhouette%2C%20dynamic%20orange%20flame%20and%20amber%20sparks%2C%20dark%20ink%20blue%20sky%2C%20cinematic%20warm%20lighting%2C%20high%20detail%20manga%20concept%20art&width=1800&height=1000&seq=naruto-hero-2026&orientation=landscape)",
        }}
      ></div>
      {/* 深色遮罩 */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-foreground-950"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/20 px-4 py-1.5 text-xs font-medium text-primary-200 md:text-sm">
          <i className="ri-fire-line"></i> 全网最全火影同人动漫合集
        </span>

        <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl md:leading-tight">
          热血剧情 · 穿越重生
          <br className="hidden md:block" /> 系统战斗 一网打尽
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-lg">
          专为火影粉丝打造的同人动漫聚合站，从原作脉络到脑洞设定，海量作品持续更新。
          点开即看最新连载，追更不迷路，满足你对火影世界的所有想象。
        </p>

        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            立即开始追更
          </a>
          <a
            href="#categories"
            className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-200 bg-background-50/10 px-7 py-3 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            浏览题材分类
          </a>
        </div>

        {/* 数据统计 */}
        <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4 border-t border-background-100/20 pt-8">
          {[
            { num: "3.2 万+", label: "连载作品" },
            { num: "1.8 亿", label: "累计阅读" },
            { num: "120 万", label: "活跃追更" },
          ].map((item) => (
            <div key={item.label} className="text-center">
              <p className="font-heading text-2xl font-black text-primary-400 md:text-3xl">
                {item.num}
              </p>
              <p className="mt-1 text-xs text-background-100 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}